import { createTheme } from '@mui/material'

export const theme = createTheme({
  palette: {
    primary: {
      main: '#141414',
    },
  },

  components: {
    MuiFormControl: {
      styleOverrides: {
        root: {
          width: '100%',
        },
      },
    },
    MuiPickersOutlinedInput: {
      styleOverrides: {
        root: {
          height: '40px',
          backgroundColor: '#f8f9fd',
        },
        notchedOutline: {
          border: '1px solid d8d8df',
        },
      },
    },
  },
})
